import React from "react";

const Layout = ({ children }) => {
  return (
    <div id="page" className="page">
      <main>{children}</main>
    </div>
  );
};

export default Layout;
